import styled from 'styled-components/macro';
import { mediumHeightScreens, mediumScreens, smallScreens } from '../../../../../common/fontElements';
import * as colors from '../../../../../common/colorConstants';

export const Title = styled.p`
  font-family: Lato;
  font-size: 14px;
  color: ${colors.darkGray9};
  margin: 0px;
  @media (max-height: ${smallScreens}) {
    font-size: 12px;
  }
  @media (max-height: ${mediumHeightScreens}) {
    font-size: 11px;
  }
`;

export const NoResultsWrapper = styled.div`
  height: 100%;
  padding: 40px;
`;

export const NoMatchText = styled.p`
  margin-top: 5px;
  font-size: 11px;
  @media screen and (max-width: ${mediumScreens}), screen and (max-height: ${mediumScreens}) {
    font-size: 10px;
  }
`;
